class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.onFocusOut = this.onFocusOut.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onMouseHover = this.onMouseHover.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);

    this.addEventListener('focusout', this.onFocusOut);
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle);
    this.addEventListener("mouseover", this.onMouseHover);
    this.addEventListener("mouseout", this.onMouseOut);
  }

  onMouseHover(){
    this.mainDetailsToggle.open = true;
  }

  onMouseOut(event){
    if (this.contains(event.relatedTarget) || this.contains(document.activeElement)) return;
    this.mainDetailsToggle.open = false;
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.alwaysOpen = this.hasAttribute('data-always-open');
    this.isDesktop = window.matchMedia('(min-width: 1280px)').matches;

    // remove close listeners
    if (this.alwaysOpen && this.isDesktop) {
      this.removeEventListener('focusout', this.onFocusOut);
      this.mainDetailsToggle.removeEventListener('toggle', this.onToggle);
      this.removeEventListener("mouseover", this.onMouseHover);
      this.removeEventListener("mouseout", this.onMouseOut);

      this.setHeaderHeight();
    }

    this.onResize = this.onResize.bind(this);
    window.addEventListener('resize', this.onResize);
  }

  onToggle() {
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', this.mainDetailsToggle.open);
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  setHeaderHeight() {
    if (!this.header) return;

    const headerHeight = this.header.getBoundingClientRect().height;
    const spacingsBase = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--spacings-base')) || 0;
    const newHeight = headerHeight + this.content.getBoundingClientRect().height - spacingsBase;

    // Set the new height as a CSS variable
    document.documentElement.style.setProperty('--header-height', `${newHeight}px`);
    // Set the new height on the header element
    this.header.style.setProperty('height', `${newHeight}px`);
  }

  onResize() {
    const wasDesktop = this.isDesktop;
    this.isDesktop = window.matchMedia('(min-width: 1280px)').matches;

    if (this.alwaysOpen && this.isDesktop && !wasDesktop) {
      this.removeEventListener('focusout', this.onFocusOut);
      this.mainDetailsToggle.removeEventListener('toggle', this.onToggle);
      this.removeEventListener("mouseover", this.onMouseHover);
      this.removeEventListener("mouseout", this.onMouseOut);
      this.mainDetailsToggle.setAttribute('open', true);
      this.setHeaderHeight();
    } else if (!this.isDesktop && wasDesktop) {
      this.addEventListener('focusout', this.onFocusOut);
      this.mainDetailsToggle.addEventListener('toggle', this.onToggle);
      this.addEventListener("mouseover", this.onMouseHover);
      this.addEventListener("mouseout", this.onMouseOut);
      this.header.style.removeProperty('height');
      const headerHeight = this.header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      this.mainDetailsToggle.removeAttribute('open');
    }
  }
}

customElements.define('header-menu', HeaderMenu);
